import React from 'react';
import { Col, Divider, Row } from 'antd';

import {
  MemberHistoryDetailsModel,
  ProfileCorporateTimesheetApproverInfoModel,
} from 'api/adminApiClient';
import HistoryLog from '../../HistoryLog';
import HistoryField from '../../HistoryField';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: MemberHistoryDetailsModel;
  historyId: string;
};

export default function TimesheetApproverInformationDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const renderTimesheetApprovers = (
    timesheetApprovers?: ProfileCorporateTimesheetApproverInfoModel[],
  ) => {
    const sectionName = 'timesheet-approver';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Timesheet approver</div>
          </Col>
          <Col xs={24}>
            {timesheetApprovers?.length ? (
              timesheetApprovers.map((timesheetApprover, index) => (
                <React.Fragment
                  key={`${timesheetApprover.timesheetApproverId}-${index}`}
                >
                  <Row gutter={[10, 10]}>
                    <HistoryField
                      title="First name"
                      value={timesheetApprover?.firstName}
                      dataId={`${sectionName}-first-name-field`}
                    />
                    <HistoryField
                      title="Last name"
                      value={timesheetApprover?.lastName}
                      dataId={`${sectionName}-last-name-field`}
                    />
                    <HistoryField
                      title="Email"
                      value={timesheetApprover?.email}
                      dataId={`${sectionName}-email-field`}
                    />
                    <HistoryField
                      title="Phone number"
                      value={timesheetApprover?.phoneNumber}
                      dataId={`${sectionName}-phone-number-field`}
                    />
                  </Row>

                  <Divider />
                </React.Fragment>
              ))
            ) : (
              <div className={styles.noDataMessage}>No data</div>
            )}
          </Col>
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderTimesheetApprovers(
        oldData?.corporateInfo?.timesheetApprovers,
      )}
      newData={renderTimesheetApprovers(
        newData?.corporateInfo?.timesheetApprovers,
      )}
    />
  );
}
